import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const NewVsRepeatedDonorsChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data) return null;

    return {
      labels: [t("New Donors"), t("Repeated Donors")],
      datasets: [
        {
          data: [data.newDonors, data.repeatedDonors],
          backgroundColor: ["#3b4cb8", "#28a745"],
          borderColor: ["#3b4cb8", "#28a745"],
          borderWidth: 1,
          hoverOffset: 10,
        },
      ],
    };
  }, [data, t]);

  const total = data.newDonors + data.repeatedDonors;
  const newPercentage = ((data.newDonors / total) * 100).toFixed(1);
  const repeatedPercentage = ((data.repeatedDonors / total) * 100).toFixed(1);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 60,
    legend: {
      display: true,
      position: "bottom",
      labels: {
        fontColor: "#666",
        usePointStyle: true,
        padding: 20,
      },
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, chartData) => {
          const dataset = chartData.datasets[tooltipItem.datasetIndex];
          const value = dataset.data[tooltipItem.index];
          const percentage = ((value / total) * 100).toFixed(1);
          return `${chartData.labels[tooltipItem.index]}: ${value} (${percentage}%)`;
        },
      },
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div>
      <div style={{ minHeight: "290px", position: "relative" }}>
        <Doughnut data={chartData} height={290} options={options} />
      </div>
      <div className="mt-3">
        <div className="row text-center">
          <div className="col-6">
            <div className="d-flex align-items-center justify-content-center" style={{ gap: "8px" }}>
              <div style={{ width: "12px", height: "12px", backgroundColor: "#3b4cb8", borderRadius: "50%" }}></div>
              <span style={{ fontWeight: "600" }}>{t("New Donors")}</span>
            </div>
            <p className="mb-0 mt-1" style={{ fontSize: "18px", fontWeight: "bold" }}>{data.newDonors}</p>
            <small className="text-muted">({newPercentage}%)</small>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center justify-content-center" style={{ gap: "8px" }}>
              <div style={{ width: "12px", height: "12px", backgroundColor: "#28a745", borderRadius: "50%" }}></div>
              <span style={{ fontWeight: "600" }}>{t("Repeated Donors")}</span>
            </div>
            <p className="mb-0 mt-1" style={{ fontSize: "18px", fontWeight: "bold" }}>{data.repeatedDonors}</p>
            <small className="text-muted">({repeatedPercentage}%)</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewVsRepeatedDonorsChart;
